<template>
    <div class="animated fadeIn">
      <Tables ref="tableGrid"
        :columns="['Número do Contrato', 'Data de Adesão', 'Segmento do consórcio', 'Situação da cota', 'Indicador de venda concluida', 'Valor saldo devedor']"
        :showTipFooter="false"
        v-on:Load="onLoad">
        <tr v-for="obj in this.objList" v-bind:key="obj.id">
          <TableColumn :IsText="true" :status="1" :value="obj.numeroContrato.toString()"/>
          <TableColumn :IsText="true" :status="1" :value="formatDate(obj.dataAdesao)" />
          <TableColumn :IsText="true" :status="1" :value="obj.segmentoConsorcio" />
          <TableColumn :IsText="true" :status="1" :value="obj.situacaoCota "/>
          <TableColumn :IsText="true" :status="1" :value="obj.indicadorVendaConcluida" />
          <TableColumn :IsText="true" :status="1" :value="obj.valorSaldoDevedor ? formatValue(obj.valorSaldoDevedor) : 'R$ 0,00'" />
        </tr>
      </Tables>
    </div>
  </template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import CarteiraConsorcioRepository from '@/shared/http/repositories/business/carteiraconsorcio.js'
import Tools from '@/components/tools/Tools'

export default {
  name: 'CarteiraConsorcio',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadCarteiraConsorcio(this.document)
      }
    },
    onLoadCarteiraConsorcio (document) {
      loading.push()
      this.document = document
      CarteiraConsorcioRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/carteiraconsorcio.vue